var fleetMap = {

	init: function () {

		$('.m-fleet-map .js-fleet-map:not(.js-fleet-map-done)').each(function() {
			var wrapper = $(this);
			var lat = parseFloat(wrapper.attr('data-latitude'));
			var lng = parseFloat(wrapper.attr('data-longitude'));
			var latLng = new google.maps.LatLng(lat, lng);
			var zoom = parseInt(wrapper.attr('data-zoom'), 10);
			var bounds = new google.maps.LatLngBounds();
			var request = null, pins = [];

			// create map
			var m = new google.maps.Map(wrapper.get(0), {
				zoom: zoom > 18 ? 18 : zoom,
				mapTypeControl: false,
				scrollwheel: false,
				streetViewControl: false,
				center: latLng
			});

			// get data
			var data = wrapper.nextAll('script[type="application/json"]:first').html();

			// parse data
			try {
				data = $.parseJSON(data);
			}
			catch (e) {
				if (console !== 'undefined') {
					console.log('Error: Could not parseJSON for fleet map: fleet-map.js')
				}
			}

			// add pins
			var _addPins = function (d) {
				// get boats
				for (var i = 0; i < d.length; i++) {
					var boat = d[i];
					var icon = {};
					var latLng = new google.maps.LatLng(parseFloat(boat.Latitude), parseFloat(boat.Longitude));

					// set icon
					var type = boat.VesselType;
					if (type.indexOf('Beam') > -1) {
						icon.url = '/images/modules/fleet-map/beam.png';
						icon.origin = new google.maps.Point(0, 0);
						icon.size = new google.maps.Size(93, 50);
						icon.anchor = new google.maps.Point(47, 50);
					}
					else if (type.indexOf('Scalloper') > -1) {
						icon.url = '/images/modules/fleet-map/scalloper.png';
						icon.origin = new google.maps.Point(0, 0);
						icon.size = new google.maps.Size(43, 40);
						icon.anchor = new google.maps.Point(22, 40);
					}
					else if (type.indexOf('Potter') > -1 && type.indexOf('Netter') > -1) {
						type = 'potter';
						icon.url = '/images/modules/fleet-map/potter.png';
						icon.origin = new google.maps.Point(0, 0);
						icon.size = new google.maps.Size(42, 29);
						icon.anchor = new google.maps.Point(21, 29);
					}
					else if (type.indexOf('Netter') > -1) {
						icon.url = '/images/modules/fleet-map/netter.png';
						icon.origin = new google.maps.Point(0, 0);
						icon.size = new google.maps.Size(67, 41);
						icon.anchor = new google.maps.Point(33, 41);
					}
					else {
						icon.url = '/images/modules/fleet-map/default.png';
						icon.origin = new google.maps.Point(0, 0);
						icon.size = new google.maps.Size(50, 31);
						icon.anchor = new google.maps.Point(25, 31);
					}

					var pin = new google.maps.Marker({
						mmsi: boat.MaritimeMobileServiceIdentity,
						icon: icon,
						position: latLng,
						map: m
					});

					pins.push(pin);

					// click event
					google.maps.event.addListener(pin, 'click', (function (pin, i) {
						return function () {
							// show loader
							popups.loader();
							// ajax
							$.ajax({
								url: '/fleetmap/vessel/json/?maritimeMobileServiceIdentity=' + pin.mmsi,
								success: function (response) {
									// hide loader
									popups.loader(true);
									// show vessel
									popups.vessel(response);
								},
								error: function (e) {
									// hide loader
									popups.loader(true, true);
									// show notice
									popups.confirm('Error', 'Sorry, something went wrong: <i>' + e.statusText.toLowerCase() + '</i>. Please try again.', '', true);
								}
							});
							// analytics
							site.analytics.track('Fleetmap Vessel Pin', 'Click', pin.mmsi);
						}
					})(pin, i));

					// extend bounds
					bounds.extend(latLng);
				}

				// fit bounds
				m.fitBounds(bounds);

				// resize
				site.win.on('resize', function () {
					m.fitBounds(bounds);
				});
			}

			_addPins(data);

			// reload
			setInterval(function () {
				if (request != null) {
					request.abort();
				}
				request = $.ajax({
					url: '/fleetmap/vessels/json/',
					cache: false,
					success: function (response) {
						// clear pins
						for (var i = 0; i < pins.length; i++) {
							pins[i].setMap(null);
						}
						pins = [];
						// redraw
						_addPins(response);
					},
					error: function (e) {
						if (e.statusText != 'abort') {
							if (console !== 'undefined') {
								console.log('Error: Could not reload map: fleet-map.js')
							}
						}
					},
					complete: function () {
						request = null;
					}
				});
			}, 600000); // 10 mins = 600000

			// done
			wrapper.addClass('js-fleet-map-done');
		});

	}

};

$(function () {
	fleetMap.init();
	site.doc.ajaxComplete(function () {
		fleetMap.init();
	});
});